import { PenaltiesService } from '@fair-play/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RevokeCardCommandPayload } from './revoke-card.command-payload';
import { RevokeUserPenaltyResponse } from '@core-http';

export class RevokeCardCommandHandler {
  private readonly penaltiesService: PenaltiesService = inject(PenaltiesService);

  revoke(payload: RevokeCardCommandPayload): Observable<RevokeUserPenaltyResponse> {
    return this.penaltiesService.revokeCard({ userPenaltyId: payload.userPenaltyId });
  }
}
